// extracted by mini-css-extract-plugin
module.exports =  {"label":"e3afc254ff--label--kUmvY","active":"e3afc254ff--active--uZ48G","title":"e3afc254ff--title--tYuHh"};